document.addEventListener("DOMContentLoaded", function() {
  const products = ["sunbeam-letter-heart-charm", "small-sunbeam-number-heart-charm"];
  
  products.forEach(handle => {
    if (document.body.classList.contains("product-" + handle)) {
      
      // Select all Infinite Options text inputs and textareas
      const inputs = document.querySelectorAll(
        ".spb-productdescfont.spb-productoptiontextcolor.spb-productoptionbackground input, " +
        ".spb-productdescfont.spb-productoptiontextcolor.spb-productoptionbackground textarea"
      );

      inputs.forEach(el => {
        el.style.fontFamily = "'Fournier Pro', Georgia, serif";
        el.style.fontSize = "1.5rem";
        el.style.textTransform = "none";
      });
    }
  });
});
